import { Run, RunStatusFilterOptions } from '@bringg/types';
import moment from 'moment/moment';

import { fieldValueGetter } from 'bringg-web/features/monitoring/shared/realtime-updates/updates/field-value-getter';
import { FilterBarListItemKeys, RunFiltersObject } from '../components/monitoring-filter-bar/types';

type GetRun = <T>(field: string, innerField?: string) => T;

type FilterActions = Record<keyof RunFiltersObject, (filters: RunFiltersObject, task: GetRun) => boolean>;

const filterActions: FilterActions = {
	[FilterBarListItemKeys.TEAMS]: (filters: RunFiltersObject, run: GetRun) =>
		filters.selectedTeams.includes(run<number>('team_id')),
	[FilterBarListItemKeys.DRIVERS]: (filters: RunFiltersObject, run: GetRun) =>
		filters.selectedUsers.includes(run<number>('user_id')),
	[FilterBarListItemKeys.ROUTES]: (filters: RunFiltersObject, run: GetRun) =>
		filters.selectedRuns.includes(run<number>('id')),
	[FilterBarListItemKeys.PLANNED_ROUTE]: (filters: RunFiltersObject, run: GetRun) =>
		filters.plannedRouteIds.includes(run<number>('planned_route_id')),
	[FilterBarListItemKeys.STATUS]: (filters: RunFiltersObject, run: GetRun) => {
		return filters.runStatus === RunStatusFilterOptions.OPEN ? !run<string>('ended_at') : !!run<string>('ended_at');
	},
	[FilterBarListItemKeys.RUN_TIME_WINDOW]: (filters: RunFiltersObject, run: GetRun) => {
		const startTime = run<string>('started_at') || run<string>('scheduled_start_time');
		const start = moment(filters.runTimeWindow).startOf('day').toISOString();
		const end = moment(filters.runTimeWindow).endOf('day').toISOString();

		return startTime >= start && startTime <= end;
	}
};

function filter(filters: RunFiltersObject, run: Run, fallback: Run) {
	return Object.keys(filters).every(filterKey => {
		return filterActions[filterKey](filters, (path: string) => fieldValueGetter.get(run, fallback, path));
	});
}

export const runsFilterer = { filter };
